export default __webpack_public_path__ + "static/media/revitPiano2.5871af3c.jpg";